export default {
  'Auckland Region': 'AK',
  'Bay of Plenty Region': 'BP',
  'Canterbury Region': 'CT',
  'Gisborne Region': 'GI',
  'Hawke\'s Bay Region': 'HB',
  'Manawatu-Wanganui Region': 'MW',
  'Marlborough Region': 'MB',
  'Nelson Region': 'NS',
  'Northland Region': 'NL',
  'Otago Region': 'OT',
  'Southland Region': 'SL',
  'Taranaki Region': 'TK',
  'Tasman Region': 'TM',
  'Waikato Region': 'WA',
  'Wellington Region': 'WE',
  'West Coast Region': 'WC',
  'No Region (Chatham Islands)': null
}
